import React, {FC, useState} from "react";
import {Button} from "components/shared";
import {BUTTON_VARIANTS} from "components/shared/Button/Button";
import {useEffect, useParams} from "pages/OrganizationPage";
import {MyInput} from "pages/StepPages/StepTwo/MyInput/MyInput";
import {useAppDispatch, useAppSelector} from "toolkit/hooks";
import {
	AddToSelectionList,
	ClearObjectsShort,
	ClearSelectionList,
	DeactivateEnumListStatus,
} from "toolkit/steps/stepThree/stepThree.slice";
import {
	changeComposition,
	changeEnumListName,
	createAddition,
	createEnumList,
	getAvailableObjectList,
	getEnumListObjectsShort,
} from "toolkit/steps/stepThree/stepThree.thunk";
import {SelectObjectList} from "../SelectObjectList/SelectObjectList";
import styles from "./AddingObjectList.module.sass";

interface AddingObjectListProps {
	close: () => void;
	title: string;
	subtitle: string;
	mode: string;
}

export const AddingObjectList: FC<AddingObjectListProps> = ({ close, title, subtitle, mode }) => {
	const [name, setName] = useState<string>("");
	const { organizationId } = useParams();
	const { selectionList, currentEnumList, enumListObjectsShort } = useAppSelector(
		(state) => state.stepThree,
	);
	const [loading, setLoading] = useState<boolean>(false);
	const dispatch = useAppDispatch();
	const [submitError, setSubmitError] = useState<boolean>(false);

	useEffect(() => {
		return () => setLoading(false);
	}, []);

	const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (!organizationId || !name.trim() || !selectionList.length) {
			setSubmitError(true);
		} else {
			setSubmitError(false);
			setLoading(true);
			switch (mode) {
				case "main":
					dispatch(
						createEnumList({
							organizationId: +organizationId,
							listName: name,
							selectionList,
							close,
						}),
					);
					break;
				case "addition":
					dispatch(
						createAddition({
							organizationId: +organizationId,
							listName: name,
							selectionList,
							close,
						}),
					);
					break;
				case "changing":
					if (!currentEnumList) break;
					if (name !== currentEnumList.listName)
						dispatch(
							changeEnumListName({
								enumListId: currentEnumList.id,
								newName: name,
							}),
						);

					let deletingList: number[] = [];
					let addingList: any = [];

					enumListObjectsShort.forEach((object) => {
						if (selectionList.findIndex((selectedObject) => selectedObject.id === object.id) < 0) {
							deletingList.push(object.id);
						}
					});

					selectionList.forEach((selectedObject: any) => {
						if (enumListObjectsShort.findIndex((originalObject: any) => originalObject.id === selectedObject.id) < 0) {
							addingList.push(selectedObject.id);
						}
					});
					if (deletingList.length || addingList.length) {
						dispatch(
							changeComposition({
								deletingList,
								addingList,
								enumListId: currentEnumList.id,
								close,
								deactivateStatus,
							}),
						);
					} else {
						close();
					}
					break;
				default:
					break;
			}
		}
	};

	const deactivateStatus = () => {
		if (currentEnumList?.newestDocApprovalDate) dispatch(DeactivateEnumListStatus());
	};

	useEffect(() => {
		if (mode === "changing")
			dispatch(getAvailableObjectList({ organizationId: Number(organizationId), enumListId: currentEnumList?.id }));
		else dispatch(getAvailableObjectList({ organizationId: Number(organizationId) }));

		return () => {
			dispatch(ClearSelectionList());
			dispatch(ClearObjectsShort());
		};
		//eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (mode === "changing" && currentEnumList) {
			enumListObjectsShort?.forEach((object) => {
				dispatch(AddToSelectionList({ id: object.id, name: object.obj.name }));
			});
			setName(currentEnumList.listName);
		}
		//eslint-disable-next-line
	}, [enumListObjectsShort]);

	useEffect(() => {
		if (mode === "changing") dispatch(getEnumListObjectsShort({ enumListId: Number(currentEnumList?.id) }));
		//eslint-disable-next-line
	}, []);

	return (
		<section className={styles.wrp}>
			<h4 className={styles.title}>{title}</h4>
			<span className={styles.subtitle}>{subtitle}</span>
			<form onSubmit={submitHandler} className={styles.form}>
				<div className={styles["form-wrp"]}>
					<MyInput
						className={styles.item}
						name="Название перечня"
						placeholder="Название"
						value={name}
						set={(e) => setName(e.target.value)}
						required={true}
						condition={submitError && !name.trim()}
						maxLength={100}
					/>
					<SelectObjectList
						condition={submitError && !Boolean(selectionList.length)}
						className={styles.item}
						mode={mode}
					/>
				</div>
				<div className={styles.btns}>
					<Button
						disabled={loading}
						onClick={close}
						type="button"
						variant={BUTTON_VARIANTS.OUTLINED}
						className={styles.button}>
						Отменить
					</Button>
					<Button loading={loading} type="submit" className={styles.button}>
						Готово
					</Button>
				</div>
			</form>
		</section>
	);
};
